module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNTEyIiB3aWR0aD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPHBhdGggZmlsbD0iIzAwNmE0ZSIgZD0iTTAgMGg1MTJ2NTEySDB6Ii8+CiAgPGNpcmNsZSBjeD0iMjMwIiBjeT0iMjU2IiByPSIxNzAuNjY3IiBmaWxsPSIjZjQyYTQxIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/bd.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/bd.svg
// module chunks = 0